import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hero-login',
  templateUrl: './hero-login.component.html',
  styleUrls: ['./hero-login.component.scss']
})
export class HeroLoginComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
